import { useL10n } from '@uplift/hooks';
import { CancelButton, CheckboxGroup, CheckboxGroupOption, FormModal, ModalActions, ModalContent, SubmitButton, TextInput } from '@uplift/ui-v2';
import { Formik } from 'formik';
import { useCallback, useMemo } from 'react';

export type NoReferModalProps = {
  patientName: string;
  open: boolean;
  onClose: (reason?: string) => void;
};

type NoReferModalForm = {
  reason: string[];
  otherReason?: string;
};

export const NoReferModal: React.VFC<NoReferModalProps> = ({ patientName, open, onClose }) => {
  const l10n = useL10n();

  const initial: NoReferModalForm = {
    reason: []
  };

  const handleSubmit = useCallback((values: NoReferModalForm) => {
    onClose([
      ...values.reason,
      values.otherReason
    ].filter(x => !!x && x !== 'other-value').join(', '));
  }, [ onClose ]);

  const handleClose = useCallback(() => {
    onClose();
  }, [ onClose ]);

  const reasons = useMemo(
    () => l10n.dashboard.actionItems.patientFilledAssessment.deferModal.reasons.map((x): CheckboxGroupOption => ({
      label: x,
      value: x
    })).concat({ label: 'Other', value: 'other-value' }),
    [ l10n.dashboard.actionItems.patientFilledAssessment.deferModal.reasons ]
  );

  return (
    <Formik initialValues={initial} onSubmit={handleSubmit}>
      {formik => (
        <FormModal
          open={open}
          onClose={handleClose}
          fullWidth
          maxWidth="md"
          title={l10n.dashboard.actionItems.patientFilledAssessment.deferModal.title(patientName)}
        >
          <ModalContent>
            <CheckboxGroup name="reason" options={reasons} />
            {formik.values.reason.includes('other-value') && (
              <TextInput
                name="otherReason"
                fullWidth
                placeholder="Other"
              />
            )}
          </ModalContent>
          <ModalActions>
            <CancelButton onClick={handleClose}>{l10n.dashboard.actionItems.patientFilledAssessment.deferModal.cancel}</CancelButton>
            <SubmitButton
              color="secondary"
              disabled={!formik.isValid || formik.isSubmitting}
              loading={formik.isSubmitting}
            >
              {l10n.dashboard.actionItems.patientFilledAssessment.deferModal.send}
            </SubmitButton>
          </ModalActions>
        </FormModal>
      )}
    </Formik>
  );
};
